async function postJson(url, payload) {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(data.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    error.code = data.code;
    throw error;
  }
  return data;
}

export const subscribeEventOptin = (email, source = 'inicio-optin') =>
  postJson('/api/events/subscribe', { email, source });
